import React from 'react';
import { Modal } from 'antd';

export interface ImagePreviewProps {
  visible: boolean;
  src: string;
  title?: string;
  width?: number;
  onClose: () => void;
}

const ImagePreview: React.FC<ImagePreviewProps> = ({ visible, src, title = '图片预览', width = 560, onClose }) => {
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      title={title}
      width={width}
      centered
    >
      {src ? (
        <div style={{ textAlign: 'center' }}>
          <img
            src={src}
            alt={title}
            style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }}
          />
        </div>
      ) : null}
    </Modal>
  );
};

export default ImagePreview; 